var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPermission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C14.34 8 14.67 8.04 15 8.09V3.27L7.5 0L0 3.27V8.18C0 12.72 3.2 16.97 7.5 18C8.05 17.87 8.58 17.68 9.1 17.45C8.41 16.47 8 15.28 8 14C8 10.69 10.69 8 14 8Z",
    fill: "#B33939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10C11.79 10 10 11.79 10 14C10 16.21 11.79 18 14 18C16.21 18 18 16.21 18 14C18 11.79 16.21 10 14 10ZM14 11.38C14.62 11.38 15.12 11.89 15.12 12.5C15.12 13.11 14.61 13.62 14 13.62C13.39 13.62 12.88 13.11 12.88 12.5C12.88 11.89 13.38 11.38 14 11.38ZM14 16.75C13.07 16.75 12.26 16.29 11.76 15.58C11.81 14.86 13.27 14.5 14 14.5C14.73 14.5 16.19 14.86 16.24 15.58C15.74 16.29 14.93 16.75 14 16.75Z",
    fill: "#B33939"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.e0a2aba5.svg";
export { ForwardRef as ReactComponent };